import { ThunkDispatch } from 'redux-thunk';

import { BestSeller, CMSApi, IntegrationApi, LiveBetting } from 'api';
import * as actionTypes from 'shared/store/action-types';
import { compareOdds, createAction } from 'shared/util/utility';

export const fetchBestsellerData = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		dispatch(createAction(actionTypes.FETCH_BESTSELLER_MATCHES_INIT));
		try {
			const bestSellerData = await BestSeller.getAllBestSellersGame();
			dispatch(
				createAction(actionTypes.FETCH_BESTSELLER_MATCHES_SUCCESS, {
					bestSellerData: bestSellerData.data.data.sports,
				}),
			);
			dispatch(createAction(actionTypes.FETCH_BESTSELLER_MATCHES_IS_ALREADY));
		} catch {
			dispatch(createAction(actionTypes.FETCH_BESTSELLER_MATCHES_FAIL));
		}
	};
};

export const fetchLiveBettingPopularData = (isAutomaticRefresh?: boolean, categoryIds?: number) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>, getState: () => any) => {
		!isAutomaticRefresh && dispatch(createAction(actionTypes.FETCH_LIVE_BETTING_POPULAR_INIT));
		try {
			const liveBettingPopularData = await LiveBetting.getLiveBettingPopular(categoryIds);
			const currentData = liveBettingPopularData.data?.data;

			if (!currentData) {
				return;
			}

			const state = getState();
			const previousData = state?.home?.popularLiveBettingData;

			if (previousData) {
				const oddsComparison = compareOdds(previousData, currentData);
				dispatch(createAction(actionTypes.SET_ODDS_COMPARISON, { oddsComparison }));
			}

			dispatch(
				createAction(actionTypes.FETCH_LIVE_BETTING_POPULAR_SUCCESS, {
					popularLiveBettingData: currentData,
					oddsComparison: compareOdds(previousData, currentData),
				}),
			);
			!isAutomaticRefresh && dispatch(createAction(actionTypes.FETCH_LIVE_BETTING_POPULAR_IS_ALREADY));
		} catch (error) {
			console.error('Error fetching live betting popular data:', error);
			dispatch(createAction(actionTypes.FETCH_LIVE_BETTING_POPULAR_FAIL));
		}
	};
};

// added automatic refresh to not put the loading state for banners while refreshing automatically if live banners.
export const fetchHotBanners = (isAutomaticRefresh?: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		!isAutomaticRefresh && dispatch(createAction(actionTypes.FETCH_HOT_BANNERS_INIT));
		try {
			const bannerData = await CMSApi.getHotBannerData();
			dispatch(
				createAction(actionTypes.FETCH_HOT_BANNERS_SUCCESS, {
					bannerData: bannerData.data.data.banners,
				}),
			);
			dispatch(createAction(actionTypes.FETCH_BANNERS_READY));
			!isAutomaticRefresh && dispatch(createAction(actionTypes.FETCH_HOT_BANNERS_INIT));
		} catch {
			dispatch(createAction(actionTypes.FETCH_HOT_BANNERS_FAIL));
		}
	};
};

export const fetchBanners = (forLogged: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		dispatch(createAction(actionTypes.FETCH_BANNERS_INIT));
		try {
			const BannerData = await CMSApi.getBannerData(forLogged);
			dispatch(
				createAction(actionTypes.FETCH_BANNERS_SUCCESS, {
					subBannerData: BannerData.data.data.subBanners,
				}),
			);
		} catch {
			dispatch(createAction(actionTypes.FETCH_BANNERS_FAIL));
		}
	};
};

export const fetchRegistrationBanners = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		dispatch(createAction(actionTypes.FETCH_REGISTRATION_BANNERS_INIT));
		try {
			const banners = await CMSApi.getRegistrationBanners();
			dispatch(
				createAction(actionTypes.FETCH_REGISTRATION_BANNERS_SUCCESS, {
					banners,
				}),
			);
		} catch {
			dispatch(createAction(actionTypes.FETCH_REGISTRATION_BANNERS_FAIL));
		}
	};
};

export const getSportEventImages = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const resp = CMSApi.getSportEventImage();
			const sportEventImages = (await resp).data.data.sportEventImages;
			dispatch(createAction(actionTypes.FETCH_SPORT_EVENT_IMAGE, { sportEventImages: sportEventImages }));
		} catch (error) {
			console.error('error: ', error);
		}
	};
};

export const getStatScoreId = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const resp = IntegrationApi.getStatsScoreId();
			const statScoreResponse = (await resp).data.data.statScoreResponse;
			dispatch(createAction(actionTypes.FETCH_STATSCORE_ID, { statScoreResponse: statScoreResponse }));
		} catch (error) {
			console.error('error: ', error);
		}
	};
};
